import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { StatementService } from '../../core/services/statement.service';
import { StatementResponse } from '../../core/models/statement-response';
import { ReconciliationService } from '../../core/services/reconciliation.service';
import { ReconRunRefDto } from '../../core/models/reconciliation';

@Component({
  selector: 'app-statement-detail',
  standalone: true,
  imports: [CommonModule, RouterModule, DatePipe],
  templateUrl: './statement-detail.component.html',
  styleUrls: ['./statement-detail.component.css'],
})
export class StatementDetailComponent implements OnInit {
  statement: StatementResponse | null = null;
  isLoading = true;
  errorMessage = '';

  runs: ReconRunRefDto[] = [];
  isRunsLoading = false;
  runsErrorMessage = '';

  isStartingRun = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private statementService: StatementService,
    private reconciliationService: ReconciliationService,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) {
      this.errorMessage = 'Statement id is missing.';
      this.isLoading = false;
      return;
    }

    this.loadStatement(id);
    this.loadRuns(id);
  }

  get canRunReconciliation(): boolean {
    return this.statement?.status === 'PROCESSED';
  }

  loadStatement(id: string): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.statementService.getStatement(id).subscribe({
      next: statement => {
        this.statement = statement;
        this.isLoading = false;
      },
      error: error => {
        console.log('Statement detail error:', error);
        this.errorMessage =
          error?.error?.message ??
          error?.message ??
          'Failed to load statement.';
        this.isLoading = false;
      },
    });
  }

  loadRuns(statementId: string): void {
    this.isRunsLoading = true;
    this.runsErrorMessage = '';

    this.reconciliationService.listRuns(statementId).subscribe({
      next: response => {
        this.runs = response.runs ?? [];
        this.isRunsLoading = false;
      },
      error: error => {
        console.log('Reconciliation runs error:', error);
        this.runsErrorMessage =
          error?.error?.message ??
          error?.message ??
          'Failed to load reconciliation runs.';
        this.isRunsLoading = false;
      },
    });
  }

  startReconciliation(): void {
    if (!this.statement || !this.canRunReconciliation || this.isStartingRun) {
      return;
    }

    this.isStartingRun = true;

    this.reconciliationService.startReconciliation(this.statement.id).subscribe({
      next: response => {
        this.isStartingRun = false;

        this.router.navigate([
          '/app/statements',
          this.statement!.id,
          'reconciliation',
          'runs',
          response.runId,
        ]);
      },
      error: error => {
        console.log('Start reconciliation error:', error);
        this.errorMessage =
          error?.error?.message ??
          error?.message ??
          'Failed to start reconciliation.';
        this.isStartingRun = false;
      },
    });
  }
}
